import { FC } from "react";
import { IOrder } from "../../../model/IOrder";
import { DetailPanel, DetailRow } from "./DetailPanel";

/**
 * Billing Info.
 *
 * The old page branched on pi_type to show each processor's own block -
 * Amazon's authorisation fields, PayPal's payer details, the LKQ gateway's AVS
 * and CVV codes. Those live in tables this backend does not map (amazon,
 * ccgw_data) or behind their own repositories, so what is shown here is the
 * payment type, the processor reference and the billing address, which is the
 * part common to every type.
 */
const OrderBilling: FC<{ order: IOrder }> = ({ order }) => (
  <DetailPanel title="Billing Info">
    <DetailRow label="Payment Type" value={order.paymentType} />
    <DetailRow label="Transaction ID" value={order.transactionId} />
    <DetailRow label="Transaction Status" value={order.affirmStatus} />
    <DetailRow label="Lender" value={order.lender} />

    <div className="h-3" />

    <DetailRow label="Name" value={order.piName} boxed />
    <DetailRow label="Street Address" value={order.piStreet} boxed />
    <DetailRow label="City and State" value={[order.piCity, order.piState].filter(Boolean).join(', ')} boxed />
    <DetailRow label="ZIP" value={order.piZip} boxed />
    <DetailRow label="Country" value={order.piCountry} boxed />
    <DetailRow label="Phone" value={order.piPhone} boxed />
    <DetailRow label="E-mail" value={order.piEmail} boxed />

    <div className="h-3" />

    <DetailRow label="Tax Exempt" value={order.isTaxExempt === null || order.isTaxExempt === undefined
      ? null
      : (order.isTaxExempt ? 'Yes' : 'No')}
    />
    <DetailRow label="User Agent" value={order.userAgent} />
  </DetailPanel>
);

export default OrderBilling;
